<template>
  <div class="interventions">
    <div class="header-intervention">
      <div class="header-info">
       Mon compte
      </div>
      <div class="button-content">
        <div class="button" v-on:click="logout">
          <i class="fa fa-sign-out" aria-hidden="true"></i> Déconnexion
        </div>
      </div>
    </div>
    <b-container class="account-content">
      <div class="information">
        <div class="header">
          <div class="title">
            <i class="fa fa-user" aria-hidden="true"></i>
            <div class="label">Informations personnelles</div>
          </div>
        </div>
        <div class="content">
          <div class="label">
            <b>Nom : </b> {{ account.nom}}
          </div>
          <div class="label">
            <b>Prénom : </b> {{ account.prenom}}
          </div>
          <div class="label">
            <b>Login : </b> {{ account.login}}
          </div>
          <div class="label">
            <b>Mail : </b> {{ account.mail}}
          </div>
          <div class="label">
            <b>Entreprise : </b> {{ account.entreprise}}
          </div>
        </div>
      </div>
      <div class="message">
       Votre session expire dans {{ token() }}
      </div>
    </b-container>
  </div>
</template>

<script>
import PullToRefresh from '../assets/js/pulltorefresh'
import moment from 'moment'
import jwt from 'jsonwebtoken'
moment.locale('fr')
export default {
  name: 'Account',
  data () {
    return {
      account: {}
    }
  },
  methods: {
    formatDate: function (date) {
      return moment(date).format('dddd DD MMMM à HH:MM')
    },
    goBackIntervention: function () {
      this.$router.go(-1)
    },
    getAccount: function (cb) {
      this.$http.get('user').then(response => {
        this.response = response.json().then((data) => {
          if (typeof cb === 'function') {
            cb()
          }
          this.account = data
        })
      }, (response) => {
        if (typeof cb === 'function') {
          cb()
        }
        this.$toast.bottom('Une erreur est survenue lors de la récupération')
      })
    },
    token: function () {
      if (localStorage.getItem('token') !== null) {
        let decoded = jwt.decode(localStorage.getItem('token'))
        let exp = moment.unix(decoded.exp)
        let unix = Math.round(+new Date() / 1000)
        let now = moment.unix(unix)
        let test = exp.diff(now)
        let duration = moment.duration(test)
        if (duration.days() !== 0) {
          return duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
        }
        return duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
      }
    },
    logout: function () {
      localStorage.removeItem('token')
      localStorage.removeItem('login')
      localStorage.removeItem('password')
      this.$router.push('/')
    }
  },
  mounted: function () {
    this.getAccount()
    var _this = this
    PullToRefresh.init({
      mainElement: '.account-content',
      onRefresh: function (cb) { _this.getAccount(cb) }
    })
  }
}
</script>
<style scoped>
.account-content{
  margin-top: 15px;
  overflow: scroll;
}
.button{

}
.header-info{
  display: inline-block;
  position: absolute;
  left: 16px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
}
.information{
  position: relative;
  background: #ffffff;
  margin-bottom: 10px;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  color: #444;
  padding: 20px 10px 10px;
}
.etat-box{
  width: 100%;
  position: relative;
  margin-bottom: 10px;
  text-align: center;
}
.etat-box > .statut.green{
  color: green;
}
.etat-box > .label{
  color: #777;
  font-size: 14px;
}
.etat-box > .statut{
  font-size: 60px;
  line-height: 1.3;
}
.information > .header{
  background-color: rgb(230, 68, 68);
  padding: 5px;
  padding-left: 10px;
  position: absolute;
  top:0;
  right: 0;
  left: 0;
  color: white;
  font-size: 14px;
}
.information > .header > .title > .fa {
  width: 15px;
  text-align: center;
}
.information > .header > .title > .label {
  display: inline-block;
}


.information > .content{
  margin-top: 25px;
}
.information > .content > .label{
  font-size: 13px;
}

.button-content > .button{
  display: inline-block;
  position: absolute;
  right: 16px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
  background-color: rgb(230, 68, 68) !important;
  border-color: rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// src/components/Account.vue